import Component from '../core/Component'

export default class FakeAutocomplete extends Component {

  term = ''
  currentTerm = null
  SEARCHED_TERMS = []
  data = []

  delayedStart = 1000
  nextStepTimeout = 0
  play = true

  listItems = []
  mapListItems = []

  // clear, autocomplete, select, map
  currentStep = 'autocomplete'

  observer = null

  constructor(element) {
    super(element)

    this.ref = {
      input: null,
      list: null,
      listMap: null,
      mapPoint: null
    }

    const autocompleteData = document.querySelector('[data-hp-fake-autocomplete]');

    // Set data from html
    this.SEARCHED_TERMS = JSON.parse(autocompleteData.dataset.search);
    this.data = JSON.parse(autocompleteData.dataset.items);

    this.currentTerm = this.SEARCHED_TERMS[0]
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          this.play = true
        } else {
          this.play = false
        }
      })
    })

    this.observer.observe(this.getElement())
  }

  prepare() {
    for (let i = 0; i < 6; i++) {
      this.listItems[i] = document.createElement('li')
      this.listItems[i].classList.add('hidden')
      this.ref.list.append(this.listItems[i])
    }

    for (let j = 0; j < this.ref.listMap.children.length; j++) {
      this.mapListItems[j] = this.ref.listMap.children[j]
    }
    setTimeout(() => {
      this.loop()
    }, this.delayedStart);
  }

  nextStep() {
    this.nextStepTimeout = 200
    if (!this.play) {
      return
    }

    // Clear input if the searched term is correct
    if (this.currentStep == 'clear') {
      this.setInputValue('')
      this.ref.input.parentElement.classList.remove('selected')
      this.currentTerm = this.getNextTerm()
      this.currentStep = 'autocomplete'
      return
    }

    // Automatic writing
    if (this.currentStep == 'autocomplete') {
      this.setInputValue((this.term + this.currentTerm.term[this.term.length]))

      if (this.term == this.currentTerm.term) {
        this.currentStep = 'select'
      }
    }

    if (this.currentStep == 'select') {
      for (let i = 0; i < 6; i++) {
        if (this.listItems[i].children[0].innerText == this.currentTerm.termToSelect) {
          this.listItems[i].classList.add('ripple')
          this.ref.input.innerText = this.listItems[i].children[0].innerText + ', ' + this.listItems[i].children[1].innerText
        }
      }
      this.ref.input.parentElement.classList.add('selected')
      this.fillAutocompleteByData([])
      this.nextStepTimeout = 800
      this.currentStep = 'showMap'
      return
    }

    if (this.currentStep == 'showMap') {
      this.listItems.forEach(li => {
        li.classList.remove('ripple')
      })

      this.mapListItems.forEach((c, i) => {
        c.style = 'transition-delay: ' + (i * 50) + 'ms'
        c.classList.remove('hidden')
      })

      this.currentStep = 'showPoint'
      return
    }

    if (this.currentStep == 'showPoint') {

      this.ref.mapPoint.classList.remove('hidden')

      this.currentStep = 'hideMap'
      this.nextStepTimeout = 4500
      return
    }

    if (this.currentStep == 'hideMap') {
      this.ref.mapPoint.classList.add('hidden')
      this.mapListItems.forEach((c, i) => {
        c.style = 'transition-delay: ' + ((3 - i) * 50) + 'ms'
        c.classList.add('hidden')
      })
      this.currentStep = 'clear'
      return
    }
  }

  loop() {
    this.nextStep()
    setTimeout(this.loop.bind(this), this.nextStepTimeout)
  }

  setInputValue(val) {
    this.term = val
    this.ref.input.innerText = val.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    this.inputChanged()
  }

  inputChanged() {
    if (this.term.length > 3) {
      this.fillAutocompleteByData(
        this.term ?
          this.data.filter((val) => {
            let hasParts = []
            this.term.split(" ").forEach((piece) => {
              hasParts.push((val.name.indexOf(piece) > -1))
            })

          return !hasParts.includes(false)
        })
        : []
      )
    }
  }

  getNextTerm() {
    let oldTerm = this.SEARCHED_TERMS.shift()
    this.SEARCHED_TERMS.push(oldTerm)

    return this.SEARCHED_TERMS[0]
  }

  fillAutocompleteByData(data) {
    for (let i = 0; i < 6; i++) {
      if (data[i]) {
        let item = data[i]
        let name = item.name

        this.term.split(" ").forEach(piece => {
          if (piece !== '' && piece !== 's' && piece !== 'st' && piece !== 'str' && piece !== 'stro' && piece !== 'stron' && piece !== 'strong') {
            name = name.replace(piece, '<strong>' + piece + '</strong>')
          }
        });

        this.listItems[i].style = 'transition-delay: '+ i*50 +'ms'
        this.listItems[i].classList.remove('hidden')
        this.listItems[i].classList.add('flag-' + item.flag)
        this.listItems[i].innerHTML = '<span>'+ name +'</span><span class="place">' + item.cityPart + '</span>'
      } else {
        this.listItems[i].style = 'transition-delay: '+ (6 - i) *50 +'ms'
        this.listItems[i].classList.add('hidden')
      }
    }
  }
}